import { ConfigurationProvider } from '@/app/interest-management/providers/configuration.provider';
import { InterestManagementController } from '@/app/interest-management/providers/interest-management.controller';
import { App } from 'vue';
import { StorageService, SubscriptionResource, TranslationService } from '../../../../../modules';
import { InterestResource } from '../../../../../modules/resource/interest/interest.resource';

export class InterestManagementControllerProvider {

    constructor(private config: ConfigurationProvider) {
    }

    install(app: App): void {
        app.provide('controller', new InterestManagementController(
            this.config,
            InterestResource.getInstance(this.config.getResourceConfiguration()),
            SubscriptionResource.getInstance(this.config.getSubscriptionResourceConfiguration()),
            app.config.globalProperties[TranslationService.identifier],
            StorageService.getInstance(this.config.getStorageConfiguration())
        ));
    }

}
